import { PriceRender } from 'components/DisplayPrice';
import SlideInLayout, { SlideInHeader }  from 'components/layouts/SlideInLayout'
import { TranslationText, HeadingText, SubHeadingText } from 'components/TextTranslationContainer'
import { Tick } from 'config/Svgs';
import { useUserWallet } from 'hooks';
import useCurrentUser from 'hooks/useCurrentUser';

const LoyaltyPopup = ({open, handleClose=()=>{}, loyaltyPolicy}) => {
  const userWallet = useUserWallet();
  const { currentUser } = useCurrentUser();

  const checkList = [
    {
      title:"Get back as loyalty credits.",
      contentProps: {
        balance: loyaltyPolicy?.specificToDelivery?.cashbackPercentage,
      },
    },
    {
      title:"Redeem your credits get up to off on your next order.", 
      contentProps:{
        percentage: loyaltyPolicy?.redeemablePercentagePerOrder,
      },
    },
    {
      title:"Limited to maximum per order.",
      contentProps:{
        amount: loyaltyPolicy?.maxRedeemableValuePerOrder,
      },
      isPrice: true,
    },
  ];
  
  return (
    <SlideInLayout 
    hideOutsideCloseButton={true}
    open={open}
    handleClose={handleClose}
    container={{className:"slide-in-coupun-card-popup"}}>
        <SlideInHeader title="Loyalty Policy" titleContentProps={{value:"🎉"}} onClose={handleClose} />
        <div className="relative px-6 pb-6 flex flex-col gap-4">
          <TranslationText className="text-dark-blue-900 text-16x font-medium" text="Collect points on every order you complete. Use them to get discounts on your next orders." />
          {currentUser && Number(userWallet) > 0 && (
            
              <div className={"px-4 py-2 border flex gap-1 border-brand-base-primary text-brand-base-primary rounded-full font-semibold w-fit"}>
                <TranslationText className="text-16x font-medium" text="You have in your wallet" />
                <PriceRender value={Number(userWallet).toFixed(2)} />
              </div>
            )}
            <HeadingText className="text-dark-blue-900 text-16x font-medium" text="How it works" />
            <ul>
               {
                checkList.map((item, index) => (
                  <li className="flex mb-4 gap-2 text-16x font-medium text-dark-blue-900 items-center" key={index}>
                   {item?.Icon ? <item.Icon /> : <Tick />}
                   <TranslationText className="text-16x font-medium text-dark-blue-900" text={item?.title} contentProps={item?.contentProps} />
                   {item?.isPrice && <PriceRender value={Number(item?.contentProps?.amount).toFixed(2)} className="text-16x font-medium text-dark-blue-900" />}
                   </li>
                ))
               }
            </ul>
        </div>
    </SlideInLayout>
  )
}

export default LoyaltyPopup